import ViewByKey from './ViewByKey';

export default ViewByKey;
